import merge from "deepmerge";
import {
    OVERRIDE_LAYOUT_CONFIG,
    OVERRIDE_PAGE_LAYOUT_CONFIG,
    RESET_LAYOUT_CONFIG, SET_CLASSNAME_BY_POSITION,
    SET_LAYOUT_CONFIG
} from "@/core/store/modules/layout/constants";

export default {
    [SET_LAYOUT_CONFIG](state, payload) {
        state.config = payload;
    },
    [RESET_LAYOUT_CONFIG](state) {
        state.config = Object.assign({}, state.initial);
    },
    [OVERRIDE_LAYOUT_CONFIG](state) {
        state.config = state.initial = Object.assign(
            {},
            state.initial,
            JSON.parse(localStorage.getItem("config"))
        );
    },
    [OVERRIDE_PAGE_LAYOUT_CONFIG](state, payload) {
        state.config = merge(state.config, payload);
    },
    [SET_CLASSNAME_BY_POSITION](state, payload) {
        const { position, className } = payload;
        if (!state.classes[position]) {
            state.classes[position] = [];
        }
        state.classes[position].push(className);
    }
}